import BaseView from './BaseView';
import DiscoverSlider from '../../components/DiscoverSlider';
import ReviewSlider from '../../components/ReviewSlider';
import LogoSlider from '../../components/LogoSlider';
import HomeHero from '../../components/HomeHero';

let view = null;

class TemplateHome extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		const homeHeroElm = this.container.querySelector('[data-home-hero]');

		if (homeHeroElm) {
			this.homeHero = new HomeHero(homeHeroElm);
		}

		this.container.querySelectorAll('[data-slider-discover]').forEach((el) => new DiscoverSlider(el));
		this.container.querySelectorAll('[data-slider-review]').forEach((el) => new ReviewSlider(el));
		this.container.querySelectorAll('[data-slider-logos]').forEach((el) => new LogoSlider(el));
	}

	destroy() {
		//
	}
}

export default {
	namespace: 'template-homepage',
	beforeEnter: ({ current, next, trigger }) => {
		view = new TemplateHome(next.container);
		view.init();

		if (!view.homeHero) {
			return;
		}

		if (current.container != null) {
			view.homeHero.skipIntroAnimation();
		} else {
			const breakpoint = window.matchMedia('(prefers-reduced-motion: reduce)');

			if (breakpoint.matches) {
				view.homeHero.skipIntroAnimation();
			} else {
				if (document.body.classList.contains('webm-alpha-supported')) {
					view.homeHero.startIntroAnimation();
				} else {
					view.homeHero.skipIntroAnimation();
				}
			}
		}
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
